export const SPECS = {
  SupportDeliveryProfilesPhase2: 'specs.stores.SupportDeliveryProfilesPhase2',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ClientFormattingForPrices: 'specs.ecom.ClientFormattingForPrices',
  separateAdditionalFee: 'specs.ecom.separateAdditionalFee',
  ShowSubscriptionsNote: 'specs.ecom.ShowSubscriptionsNote',
  SortOptionsByPrice: 'specs.ecom.SortOptionsByPrice'
};
//# sourceMappingURL=specs.js.map